export default {
  header: 'Nye ordrer sat på pause',
  text: 'Tryk hvor som helst for at genoptage',
};
